import React, { Component } from 'react';
import firebase from 'firebase';

import ProcedureItemComponent from './ProcedureItemComponent';
import PaginationComponent from './PaginationComponent';
import LanguageFilter from './LanguageFilter';

import CurrentUser from "../../public/core/PublicUserSessionContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { userCanAccessAula } from '../../../utils/aula.utils';
import { getProcedure } from '../../../service/procedures';
import { getEnabledTranslationLanguages } from '../../../service/procedureTranslations';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../../../service/constants';
import { parseLanguageQueryParams, serializeLanguageQueryParams, pickDisplayLanguage } from '../../../utils/language.utils';

class ProceduresComponent extends Component {
    constructor(props) {
        super(props);
        const { match: { params }, location } = this.props;
        const filters = {};
        filters[params.type] = params.filter;
        
        const searchParams = new URLSearchParams(location.search);
        const queryLanguages = parseLanguageQueryParams(searchParams);
        let defaultLanguages = queryLanguages.length === 0 ? [] : queryLanguages;
        
        if (defaultLanguages.length > 0 && SUPPORTED_LANGUAGES.every(lang => defaultLanguages.includes(lang))) {
            defaultLanguages = [];
        }
        
        this.state = {
            docs: [],
            proceduresCollection: firebase.firestore().collection('procedures'),
            filters: { kynd: filters.kynd, tag: filters.tag, type: filters.type, aula: filters.aula }, 
            isFiltering: true, 
            pagination: { numberElements: 9 },
            otherLanguagesPagination: { numberElements: 9 },
            aulas: [],
            aulaFilter: "Todos",
            selectedLanguages: defaultLanguages,
            availableLanguagesById: {},
            otherLanguagesProcedures: [[]],
            tags: [],
        };
    }

    componentWillMount = () => {
        const currentUser = this.context.currentUser;
        
        firebase.firestore().collection('tags').get().then((snapshot) => {
            const tags = [];
            snapshot.docs.map((doc) => tags.push({ id: doc.id, ...doc.data() }));
            this.setState({ tags });
            this.getFilteredProcedures();
        });

        firebase.firestore().collection('aulas').get().then((aulasColl) => {
            let aulas = []
            aulasColl.docs.forEach(aula => {
                if (userCanAccessAula(currentUser.id, aula.data()))
                    aulas.push({ id: aula.id, ...aula.data() })
            })
            this.setState({ aulas })
        });
    }

    getFilteredProcedures = async (newFilters) => {
        this.context.iniciaCarga();
        const filters = newFilters ? newFilters : this.state.filters;
        let query = this.state.proceduresCollection;
        if (filters.kynd) {
            query = query.where(`kynd`, '==', filters.kynd);
        }
        if (filters.tag) {
            query = query.where(`tags.${filters.tag}`, '==', true);
        }
        if (filters.type) {
            query = query.where(`type`, '==', filters.type);
        }
        try {
            const snapshot = await query.get();
            let docsToPaginate;
            if (filters.aula) {
                let filteredDocs = []
                let currentAula = this.state.aulas.find(aula => filters.aula === aula.id)
                if (currentAula && currentAula.videos && Array.isArray(currentAula.videos)) {
                    snapshot.docs.forEach(doc => {
                        if (currentAula.videos.includes(doc.id)) {
                            filteredDocs.push(doc)
                        }
                    })
                }
                docsToPaginate = filteredDocs;
            } else {
                docsToPaginate = snapshot.docs;
            }
            await this.paginateProcedures(docsToPaginate, true, filters);
        } catch (error) {
            console.log(error);
        } finally {
            this.context.terminaCarga();
        }
    }

    paginateProcedures = async (docs, isNewData, newFilters) => {
        const procedures = [[]];
        const pagination = this.state.pagination;
        const selectedLanguages = this.state.selectedLanguages;
        const availableLanguagesById = {};
        
        const proceduresWithTranslations = await Promise.all(
            docs.map(async (doc) => {
                const enabledLanguages = await getEnabledTranslationLanguages(doc.id);
                availableLanguagesById[doc.id] = enabledLanguages;
                
                let procedureData = { id: doc.id, ...doc.data() };
                
                if (selectedLanguages.length > 0) {
                    const hasAnySelectedLanguage = selectedLanguages.some(lang => enabledLanguages.includes(lang));
                    if (!hasAnySelectedLanguage) {
                        return null;
                    }
                    
                    const displayLanguage = pickDisplayLanguage(enabledLanguages, selectedLanguages);
                    if (displayLanguage !== DEFAULT_LANGUAGE) {
                        const translatedProcedure = await getProcedure(doc.id, displayLanguage, false);
                        procedureData = translatedProcedure || procedureData;
                    }
                }
                
                return procedureData;
            })
        );
        
        const filteredProcedures = proceduresWithTranslations.filter(p => p !== null);
        
        filteredProcedures.forEach((procedure, index) => {
            const page = Math.ceil((index + 1) / this.state.pagination.numberElements);
            if (procedures.length <= page) {
                procedures.push([]);
            }
            procedures[page].push(procedure);
        });
        
        pagination.numberPages = procedures.length - 1;
        pagination.actualPage = 1;
        pagination.active = (pagination.numberPages > 1);
        const filters = newFilters ? newFilters : this.state.filters;
        const backDocs = isNewData ? docs : this.state.docs;
        
        let otherLanguagesProcedures = [[]];
        if (selectedLanguages.length > 0) {
            const otherDocs = docs.filter(doc => {
                const enabledLanguages = availableLanguagesById[doc.id] || [DEFAULT_LANGUAGE];
                return !selectedLanguages.some(lang => enabledLanguages.includes(lang));
            });
            
            const otherProceduresWithTranslations = otherDocs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            
            otherProceduresWithTranslations.forEach((procedure, index) => {
                const page = Math.ceil((index + 1) / this.state.otherLanguagesPagination.numberElements);
                if (otherLanguagesProcedures.length <= page) {
                    otherLanguagesProcedures.push([]);
                }
                otherLanguagesProcedures[page].push(procedure);
            });
        }
        
        const otherLanguagesPagination = {
            ...this.state.otherLanguagesPagination,
            numberPages: otherLanguagesProcedures.length - 1,
            actualPage: 1,
            active: (otherLanguagesProcedures.length - 1) > 1
        };
        
        this.setState({ 
            procedures, 
            docs: backDocs, 
            filters, 
            isFiltering: false, 
            pagination,
            availableLanguagesById,
            otherLanguagesProcedures,
            otherLanguagesPagination
        });
    }

    handlePagination = (page) => {
        const pagination = this.state.pagination;
        pagination.actualPage = page;
        const otherLanguagesPagination = {
            ...this.state.otherLanguagesPagination,
            actualPage: 1
        };
        this.setState({ pagination, otherLanguagesPagination }, () => {
            window.scrollTo(0, 0);
        });
    }

    filterByKynd = (kynd) => {
        const filters = this.state.filters;
        filters.kynd = kynd;
        this.getFilteredProcedures(filters);
    }

    filterByTag = (tag) => {
        const filters = this.state.filters;
        filters.tag = tag;
        this.getFilteredProcedures(filters);
    }

    filterByType = (type) => {
        const filters = this.state.filters;
        filters.type = type;
        this.getFilteredProcedures(filters);
    }

    filterByAula = (aula) => {
        const filters = this.state.filters;
        filters.aula = aula;
        this.getFilteredProcedures(filters);
    }

    filterByLanguage = (selectedLanguages) => {
        this.setState({ selectedLanguages }, () => {
            const searchParams = new URLSearchParams(this.props.location.search);
            const langsParam = serializeLanguageQueryParams(selectedLanguages);
            if (langsParam) {
                searchParams.set('langs', langsParam);
            } else {
                searchParams.delete('langs');
            }
            this.props.history.replace({
                pathname: this.props.location.pathname,
                search: searchParams.toString()
            });
            this.getFilteredProcedures(this.state.filters);
        });
    }

    handleOtherLanguagesPagination = (page) => {
        const otherLanguagesPagination = this.state.otherLanguagesPagination;
        otherLanguagesPagination.actualPage = page;
        this.setState({ otherLanguagesPagination }, () => {
            window.scrollTo(0, 0);
        });
    }

    searchByName = (event) => {
        const value = event.target.value;
        const docs = this.state.docs;
        const newDocs = [];
        let tagsToLook = [];
        (this.state.tags || []).forEach(tag => {
            if (tag && tag.name && tag.name.toLowerCase().includes(value.toLowerCase())) {
                tagsToLook.push(tag.id);
            }
        })

        docs.map((doc) => {
            let data = doc.data() || {};
            let splittedMeta = (data.meta || "").split(",").map(meta => meta.trim());
            if (data.name && data.name.toLowerCase().includes(value.toLowerCase())) {
                newDocs.push(doc)
            }
            else if (data.detail && data.detail.toLowerCase().includes(value.toLowerCase())) {
                newDocs.push(doc)
            }
            else if (data.tags && tagsToLook.some(tagId => {
                if (data.tags[tagId]) {
                    return true;
                }
            }
            )) {
                newDocs.push(doc);
            }

            else if (
                splittedMeta.some(
                    meta => {
                        return meta.toLowerCase().includes(value.toLowerCase())
                    }
                )
            ) {
                newDocs.push(doc);
            }
        });

        //console.log(docs);
        //console.log(newDocs);
        this.paginateProcedures(newDocs);
    }


    render() {
        if (this.state.isFiltering) {
            return false;
        }
        const procedures = this.state.procedures;
        const actualPage = this.state.pagination.actualPage;
        const currentUser = this.context.currentUser;
        const tags = this.state.tags;
        return (
            <section className="video-grid">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-12">
                            <div className="video-title-bar d-md-flex justify-content-between">
                                <h1 className="main-title">
                                    Catálogo de cirugías
                                </h1>
                                <div>
                                    <div className="mb-3 p-0 row no-gutters align-items-center">
                                        <div className="col">
                                            <input onChange={this.searchByName} className="form-control form-control-borderless" type="search" placeholder="Buscar en catálogo" />
                                        </div>
                                        <div className="col-auto pl-3 pr-3">
                                            <a>
                                                <FontAwesomeIcon icon={faSearch} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-md-4 col-sm-5 col-12" >
                                    <div className=" filter-sidebar">
                                        <span className="h4">Filtros</span>
                                        <p  >Aulas virtuales</p>
                                        <ul className="list-unstyled pl-3">
                                            {this.state.aulas.map(aula => {
                                                return <li className={this.state.aulaFilter === aula.id ? "Gratis active" : "Gratis"}><button onClick={e => {
                                                    this.setState({ aulaFilter: aula.id }, () => this.filterByAula(aula.id))

                                                }}>{aula.title}</button></li>
                                            })}
                                            <li className={this.state.aulaFilter === "Todos" ? "Gratis active" : "Gratis"}><button onClick={e => {
                                                this.setState({ aulaFilter: "Todos" }, () => this.filterByAula(false))

                                            }}>Todos</button></li>
                                        </ul>
                                        <p  >Tipo</p>
                                        <ul className="list-unstyled pl-3">
                                            <li className={this.state.filters.type === "Gratis" && "active"}><button onClick={e => this.filterByType('Gratis')}>Gratis</button></li>
                                            <li className={this.state.filters.type === "Premium" && "active"}><button onClick={e => this.filterByType('Premium')}>Premium</button></li>
                                            <li className={!this.state.filters.type && "active"}><button onClick={e => this.filterByType(false)}>Todos</button></li>
                                        </ul>
                                        <LanguageFilter 
                                            selectedLanguages={this.state.selectedLanguages}
                                            onLanguageChange={this.filterByLanguage}
                                        />
                                        <p  >Especie</p>
                                        <ul className="list-unstyled pl-3">
                                            <li className={this.state.filters.kynd === "Perro" && "active"} ><button onClick={e => this.filterByKynd('Perro')}>Perro</button></li>
                                            <li className={this.state.filters.kynd === "Gato" && "active"} ><button onClick={e => this.filterByKynd('Gato')}>Gato</button></li>
                                            <li className={this.state.filters.kynd === "Otras especies" && "active"} ><button onClick={e => this.filterByKynd('Otras especies')}>Otras especies</button></li>
                                            <li className={!this.state.filters.kynd && "active"} ><button onClick={e => this.filterByKynd(false)}>Todas</button></li>
                                        </ul>
                                        <p  >Etiquetas</p>
                                        <ul className="list-unstyled pl-3">
                                            {tags && tags.map(tag => {
                                                return (
                                                    <li className={this.state.filters.tag === tag.id && "active"}><button onClick={e => this.filterByTag(tag.id)}>{tag.name}</button></li>
                                                )
                                            })}

                                            <li className={!this.state.filters.tag && "active"}><button onClick={e => this.filterByTag(false)}>Todas</button></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-9 col-md-8 col-sm-7 col-12" >
                                    {procedures[actualPage] && procedures[actualPage].length > 0 ? (
                                        <>
                                            <div className="row">
                                                {procedures[actualPage].map(procedure => {
                                                    const availableLanguages = this.state.availableLanguagesById[procedure.id] || [DEFAULT_LANGUAGE];
                                                    const displayLanguage = pickDisplayLanguage(availableLanguages, this.state.selectedLanguages);
                                                    return (
                                                        <ProcedureItemComponent 
                                                            key={procedure.id} 
                                                            procedure={procedure} 
                                                            userType={currentUser.type}
                                                            availableLanguages={availableLanguages}
                                                            displayLanguage={displayLanguage}
                                                        />
                                                    );
                                                })}
                                            </div>

                                            <div className="row justify-content-center">
                                                {this.state.pagination.active &&
                                                    <PaginationComponent pagination={this.state.pagination} handlePagination={this.handlePagination} />
                                                }
                                            </div>
                                        </>
                                    ) : this.state.selectedLanguages.length > 0 ? (
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="text-center mt-4 mb-4">No hay vídeos disponibles en el idioma seleccionado</p>
                                            </div>
                                        </div>
                                    ) : null}

                                    {this.state.selectedLanguages.length > 0 && 
                                     this.state.otherLanguagesProcedures.length > 1 &&
                                     this.state.otherLanguagesProcedures[this.state.otherLanguagesPagination.actualPage] &&
                                     this.state.otherLanguagesProcedures[this.state.otherLanguagesPagination.actualPage].length > 0 &&
                                     (this.state.pagination.actualPage === this.state.pagination.numberPages || 
                                      !procedures[actualPage] || procedures[actualPage].length === 0) && (
                                        <div className="row">
                                            <div className="col-12 separator" style={{ height: '1.25px', backgroundColor: '#000', margin: '2rem 1rem' }} ></div>

                                            <div className="col-12">
                                                <h2 className="mb-4">Disponible en otros idiomas</h2>
                                                <div className="row">
                                                    {this.state.otherLanguagesProcedures[this.state.otherLanguagesPagination.actualPage].map(procedure => {
                                                        const availableLanguages = this.state.availableLanguagesById[procedure.id] || [DEFAULT_LANGUAGE];
                                                        return (
                                                            <ProcedureItemComponent 
                                                                key={procedure.id} 
                                                                procedure={procedure} 
                                                                userType={currentUser.type}
                                                                availableLanguages={availableLanguages}
                                                                displayLanguage={DEFAULT_LANGUAGE}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                                <div className="row justify-content-center mt-3">
                                                    {this.state.otherLanguagesPagination.active &&
                                                        <PaginationComponent 
                                                            pagination={this.state.otherLanguagesPagination} 
                                                            handlePagination={this.handleOtherLanguagesPagination} 
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
ProceduresComponent.contextType = CurrentUser;
export default ProceduresComponent;